import { useQuery } from '@tanstack/react-query';
import { getSavedBankAddresses } from '../requests';

export function useGetSavedBankAddresses() {
  const query = useQuery({
    queryKey: ['operations/bank/template'],
    queryFn: () => getSavedBankAddresses(),
    staleTime: 0,
    gcTime: 0,
    retry: 0,
  });

  return {
    data: query.data?.templates ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    status: query.status,
  };
}
